import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import {
  closeFilterDropdown,
  fetchGeoFilters,
  resetGeoFilters,
  toggleFilterDropdown,
} from '../../../../store/slice/filter-slice';
import Button from '../../Common/Button';
import FiltersSetup from './FiltersSetup';
import filters_icon from '../../../../assets/img/svg/buttons/filter.svg';
import { useLocation } from 'react-router-dom';
import { CASH_REGISTER_URL } from '../../../../util/url';
import { FilterType } from '../../../../enum/FilterType';
import { resetGlobalFilters } from '../../../../store/slice/global-filters';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { resetCashRegister } from '../../../../store/slice/cash-register-slice';
import useDateAndTime from '../../../../hook/useDateAndTime';

const payload = {
  CompanyID: null,
  RegionID: null,
  GroupID: null,
  LocationID: null,
  DeviceID: null,
  GetAllAbove: false,
  GetAllBelow: false,
  GetUserLevel: true,
};

const CustomFilter = () => {
  const dispatch = useAppDispatch();
  const { startDate } = useDateAndTime();

  const initialStartDateRef = useRef(startDate);
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const isCashRegister = location.pathname === CASH_REGISTER_URL;

  useEffect(() => {
    dispatch(resetGeoFilters());
    dispatch(resetGlobalFilters());

    if (!isCashRegister) {
      dispatch(resetCashRegister());
    }
  }, [location.pathname, dispatch, isCashRegister]);

  const openFilters = () => {
    dispatch(toggleFilterDropdown());
  };

  useEffect(() => {
    dispatch(
      fetchGeoFilters({
        ...payload,
        StartDate: initialStartDateRef.current,
      }),
    );
  }, [dispatch]);

  const filters = useAppSelector((state) => state.globalFilters);
  const filterType = useAppSelector((state) => state.globalFilters.filterType);
  const openFilterDropDown = useAppSelector((state) => state.filters.openFilterDropDown);

  const shouldListenClose = !(
    filterType === FilterType.CASH_REGISTER_FILTERS &&
    (!filters.Group || filters.Group.length === 0)
  );

  useEffect(() => {
    if (!shouldListenClose) return;

    const handleClose = () => {
      if (menuRef.current && document.activeElement && menuRef.current.contains(document.activeElement)) {
        return;
      }

      dispatch(closeFilterDropdown());
    };

    const handleClickOutside = (e: Event) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        handleClose();
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('pointerdown', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, [shouldListenClose, dispatch]);

  return (
    <div data-pw="filters" className="filter_button_wrapper">
      <div ref={menuRef} className="filter_button_container">
        <Button
          icon={filters_icon}
          onClick={openFilters}
          variant={`${openFilterDropDown ? 'filled' : ''}`}
          className="filter_button"
        />
        <FiltersSetup />
      </div>
    </div>
  );
};
export default CustomFilter;
